import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getObjectByCache } from '@/utils/basicDataCache'
import * as NumberUtils from '@/utils/NumberUtils'

export class CurrencyUtil {
  static currencyMap = new Map() // 币种缓存map
  constructor() {
  }

  // 获取币种汇率小数位数
  static getCurrencyRateDigits(currency) {
    if (!currency) {
      return 6
    }
    let obj = this.currencyMap.get(currency)
    if (!obj) {
      obj = getObjectByCache(TYPE_NAMES.basic_data_Currency, 'code', currency)
      if (!obj) {
        return 6
      }
      this.currencyMap.set(currency, obj)
    }
    return obj.rateFractionDigits || 6
  }

  // 根据币种截取汇率
  static truncateRateByCurrency(currency, rate) {
    const digits = this.getCurrencyRateDigits(currency)
    return NumberUtils.truncateDecimals(rate, digits)
  }

  // 根据币种格式化汇率
  static formatRateByCurrency(currency, rate) {
    const digits = this.getCurrencyRateDigits(currency)
    return NumberUtils.formatNumber(rate, digits)
  }

  // 根据币种四舍五入汇率
  static roundHalfUpRateByCurrency(currency, rate) {
    const digits = this.getCurrencyRateDigits(currency)
    return NumberUtils.roundHalfUp(rate, digits)
  }
}
